import '../../../js/core.js';
import './page-eos-sat.less';
import '../../../js/video-youtube-iframe.js'

$(function () {
  import('owl.carousel/src/js/owl.carousel').then(()=>{
    import('owl.carousel/src/js/owl.navigation').then(()=>{
        jQuery(".js-slider-our-misson").owlCarousel({
          responsive: {
            0: {
              dots: false,
            },
            768: {
              dots: true,
            },
          },
          loop: true,
          nav: true,
          items: 1
        });

    });
  });
});


